//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { createStore } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

//  -- Middleware ---------------------
import middleware from 'store/_middleware';

//  -- Reducers -----------------------
import rootReducer from 'store/reducer';

//  -- Config -------------------------
const persistConfig = {
    key: 'root',
    storage,
    blacklist: [
        'activity',
        'classes',
        'classActivities',
        'classQuizzes',
        'classUsers',
        // 'currentClass',
        // 'currentOrg',
        'interactions',
        'notes',
        'organizations',
        'quiz',
        'questions',
        'submissions',
        'userClasses',
        'users',
        'profile_picture_picker',
        'tipsByBook',
        'books',
        'bookUnitList',
        'alertView',
        'messageAlertView',
        'booksAllList',
        'chatUser',
        'chatMessages',
        "timmerRunning",
        // 'booksAllList',
        'servertime',
       
        'feedbackForm',
        'feedback',
        'socketConnection',
        'userChatConfig',
        'scheduledMessage',
        'schoologyGradeCategory',
        'schoologyAllClassGradeCategory',
        'schoologyAssignment',
        'wheelModal',
        'activities',
        'userBooksList',
        'quizzes',
        'literacy_purpose',
        'ideas',
        'ideaModal',
        'playGameModal',
        'oneGameModal',
        'currentGameSession',
        'debateModal',
        'oneway_teacher_video',
        'one_game_video',
        'howToVideos',
        'standards',
        'class_game_activity',
        'distDashboardInfo',
        'distExamGraphData',
        'distBookUsesData',
        'distContentExamData',
        'class_user_logs',
        'mainbookPageView',
        'ebookGalleryView',
        'checkListModal',
        'noiseModal',
        'trafficModal',
        'sentenceView',
        'ebook_highlights',
        'non_native_ebook_highlights',
        'answerView',
        'pdfView',
        'rubrices',
        'audioPlayer',
        'loaderClassActivityAndQuiz',
        'googleCourseMapByDistrict',
        'widgetWheelReducer',
        'widgetGroupReducer',
        'widgetStationReducer',
        'aiAnswerView',
        'all_district_teacher',
        'canvasAuthDistrict',
        'notifications',
        'welcomeVideos',
        'tipsBook',
        'classNotes',
        'story',
        'videos',
        'bingoModal',
        'placement_exam_distict_assignment',
        'placement_exam_list' , 
        'placement_exam_submission_by_examcode',
        'book_pages_translations',
        'vocabulary_cogantes',
        'translationPractice',
        'chatState',
        'one_game_gallery',
        'one_game_category',
        'oneStoryWithAi',
        'oneClassStory',
        'storyView',
        'book_grammar_content',
        'book_vocab_content',
        'worksheetViewReducer',
        'worksheetReducer',
        'worksheetImageReducer',
        'articleLevels',
        'vocab_permission_for_user',
        'wordBankReducer',
        'studentGroupReducer',
        'UI',
        'sentenceStarter',
        'sentenceStarterPopup',
        'adminHomeInfo',
        'extra_resource_book',
        'image_gallery',
        'userAllowedBooks',
        'lessonPlansByBook',
        'lessonPlansByBookAndUser',
        'booksCoverList'
    ]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);


//  ----------------------------------------------------------------------------
//  Store function
//  ----------------------------------------------------------------------------

const configureStore = () => {
    const store = createStore(persistedReducer, undefined, middleware);
    return store;
};

export default configureStore;
